import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { A } from 'components/common/Link/Link'
import Icon from 'components/common/Icon/Icon'
import Text from 'components/common/Text/Text'

export const StoreContactsLineText = ({ asset = 'arrow', value, ...props }) =>
  <Wrapper>
    <Text { ...props }>
      <IconWrapper>
        <Icon asset={ asset } margin="-2px 9px 0 0" alt="" />
      </IconWrapper>
      { value }
    </Text>
  </Wrapper>

StoreContactsLineText.propTypes = {
  asset: PropTypes.string,
  value: PropTypes.string
}

export const StoreContactsLineA = ({ asset = 'arrow', url, value, ...props }) =>
  <Wrapper>
    <A href={ url } bolder { ...props }>
      <IconWrapper>
        <Icon asset={ asset } margin="-2px 9px 0 0" alt="" />
      </IconWrapper>
      { value }
    </A>
  </Wrapper>

StoreContactsLineA.propTypes = {
  asset: PropTypes.string,
  url: PropTypes.string,
  value: PropTypes.string
}

const Wrapper = styled.div`
  & + & {
    padding-top: 19px;
  }
`

const IconWrapper = styled.span`
  display: inline-block;
  width: 30px;
  text-align: center;
`
